// extracted by mini-css-extract-plugin
export default {"title":"EvaluationQuestions_title__puDYc"};